/**
 * sunlightMatch - Licht-Abgleich Zone ↔ Pflanzen-Lichtbedarf (#606)
 *
 * Vergleicht die berechnete Lichtzone an der Pflanzposition (Jahresübersicht)
 * mit dem `sunlight`-Enum der Pflanze. Mapping laut Plan §3.5 — eine
 * Liste passt, wenn EINE Angabe passt. Orientierungshilfe, keine Alarm-Logik.
 */

// Zone → passende sunlight-Enum-Werte
const ZONE_SUNLIGHT = {
  full: ['full_sun', 'sun-partial_shade', 'partial_sun'],
  partial: ['sun-partial_shade', 'partial_sun', 'partial_shade'],
  shade: ['partial_shade', 'full_shade'],
};

/** Menschliche Labels der sunlight-Enum-Werte. */
export const SUNLIGHT_LABELS = {
  full_sun: 'volle Sonne',
  'sun-partial_shade': 'Sonne bis Halbschatten',
  partial_sun: 'Teilsonne',
  partial_shade: 'Halbschatten',
  full_shade: 'Vollschatten',
};

/** sunlight kann String oder Liste sein → immer als Array (leer = unbekannt). */
export function normalizeSunlight(sunlight) {
  if (Array.isArray(sunlight)) return sunlight.filter(Boolean);
  if (typeof sunlight === 'string' && sunlight.trim()) return [sunlight.trim()];
  return [];
}

/**
 * Passt der Lichtbedarf zur Zone?
 * @returns {'ok'|'mismatch'|'unknown'}
 */
export function matchesZone(zone, sunlight) {
  const allowed = ZONE_SUNLIGHT[zone];
  const values = normalizeSunlight(sunlight);
  if (!allowed || values.length === 0) return 'unknown';
  return values.some((v) => allowed.includes(v)) ? 'ok' : 'mismatch';
}

/** Lesbare Aufzählung des Lichtbedarfs („volle Sonne oder Teilsonne"). */
export function sunlightPreferenceText(sunlight) {
  const labels = normalizeSunlight(sunlight).map((v) => SUNLIGHT_LABELS[v] || v);
  return labels.join(' oder ');
}
